import PropTypes from 'prop-types';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { Icon } from './Icon';

export const PageTitle = ({
  title = 'The Page Title has not been set.',
  subTitle,
  viewMode,
  onToggleViewMode,
  containerClass = '',
}) => (
  <Container fluid className="bg-lighter border-bottom mb-4 py-4 px-0">
    <Container className={containerClass}>
      <Row className="align-items-center">
        <Col className="text-center text-sm-left">
          <h1 className="h2 m-0">{title}</h1>
          {subTitle && <p className="m-0">{subTitle}</p>}
        </Col>
        {viewMode && onToggleViewMode && (
          <Col className="col-12 col-sm-auto text-center mt-3 mt-sm-0">
            <Button onClick={onToggleViewMode} style={{ minWidth: '95px' }}>
              <Icon icon={viewMode === 'grid' ? 'map-marker' : 'grid'} className="mr-1 lead" />
              <span className="d-none d-sm-inline">{viewMode === 'grid' ? 'Map' : 'Grid'}</span>
              <span className="d-inline d-sm-none">{viewMode === 'grid' ? 'Map' : 'List'}</span>
            </Button>
          </Col>
        )}
      </Row>
    </Container>
  </Container>
);

PageTitle.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  viewMode: PropTypes.oneOf(['grid', 'map']),
  onToggleViewMode: PropTypes.func,
};
